
// This file is auto-generated on 'sanity dev'
// Modifications to this file is automatically discarded
import {renderStudio} from "sanity"
import studioConfig from "../../sanity.config.ts"

renderStudio(
  document.getElementById("sanity"),
  studioConfig,
  {reactStrictMode: false, basePath: "/"}
)
